var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_month_FILL0_wght400_GRAD0_opsz48",
    d: "M13.2,13.6a.786.786,0,1,1,.57-.23A.774.774,0,0,1,13.2,13.6Zm-3.2,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,10,13.6Zm6.4,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,16.4,13.6Zm-3.2,3.2a.786.786,0,1,1,.57-.23A.774.774,0,0,1,13.2,16.8Zm-3.2,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,10,16.8Zm6.4,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,16.4,16.8ZM7.2,20A1.23,1.23,0,0,1,6,18.8V6.4A1.23,1.23,0,0,1,7.2,5.2H8.5V4H9.8V5.2h6.8V4h1.3V5.2h1.3a1.23,1.23,0,0,1,1.2,1.2V18.8A1.23,1.23,0,0,1,19.2,20Zm0-1.2h12V10.2H7.2v8.6ZM7.2,9h12V6.4H7.2Zm0,0V6.4h0Z",
    transform: "translate(-6 -4)",
    fill: "#545455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.67dc631fb6e4e97ab98e126b49178327.svg";
export { ForwardRef as ReactComponent };